import './styles/theme.scss';

import './vue/main';
import Vue from 'vue';
import './scripts/utils/smoothscroll';

// Collection
globalThis.PSTheme.Vue.Collection = new Vue({
  name: 'CollectionWrapper',
  components: {
    collection: require('./vue/templates/Collection.vue').default,
  },
}).$mount('.collection');
